export const TOGGLE_CURRENCY = "TOGGLE_CURRENCY"
export const TOGGLE_FGCTITLE = "TOGGLE_FGCTITLE"
